import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { LupasComponent } from '../../general/lupas/lupas.component';
import { BotoneraApiService } from '../botonera.api.service';
import { IPaso, ISaltarPasoAdmin } from '../botonera.interface';
import { IFormSearchLupa, Item } from '../../general/lupas/interfaces/lupas.interfaces';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-modal-saltar-paso-admin',
  standalone: true,
  imports: [ReactiveFormsModule, ButtonModule, LupasComponent],
  templateUrl: './modal-saltar-paso-admin.component.html',
})
export class ModalSaltarPasoAdminComponent {
    ref = inject(DynamicDialogRef);
    config = inject(DynamicDialogConfig);
    apiService = inject(BotoneraApiService);
  
    form: FormGroup = new FormGroup({});
    request: ISaltarPasoAdmin;
  
    // lupa
    dataSearchLupaPasoDestino: IFormSearchLupa = {
      idFormulario: 'noFormMotivosSaltarPasoAdmin',
      campo: 'SaltarPasoAdmin',
      label: 'Saltar paso',
      dependencias: { CodfdCabecera: null, IdfdCuerpo: null, CodfdSubTipoDocumental: null },
      required: true,
    };
  
    constructor() {
      this.request = this.config.data;
      this.buildForm();
      this.setDependenciasLupa();
    }
  
    async confirmar() {
      // recoge el motivo
      this.request.Motivo = this.form.get('Motivo')?.value;
      // envia la solicitud al API
      const response = await lastValueFrom(this.apiService.PutSaltarPasoAdmin(this.request));
      // cierra el modal retornando la respuesta
      this.ref.close(response);
    }
  
    cerrarModal() {
      this.ref.close(false);
    }
  
    // Lupa
    buildForm() {
      this.form = new FormGroup({
        Codigo: new FormControl(null, Validators.required),
        Motivo: new FormControl(null, Validators.required),
      });
    }

    onPasoSeleccionado(item: Item) {
      const propertiesPasoDestino = (item.Propiedades ?? {}) as IPaso;
      this.request.CodfdCuerpoDestino = Number(propertiesPasoDestino.CodfdCuerpo); 
      this.request.CodfdDocPermitidos = Number(propertiesPasoDestino.CodfdDocPermitidos);
     // this.request.CodGlobal = this.request.CodGlobal2;
    }
  
    setDependenciasLupa() {
      this.dataSearchLupaPasoDestino.dependencias = {
        CodfdCabecera: this.request.CodfdCabecera,
        IdfdCuerpo: this.request.CodfdCuerpo,
        CodfdSubTipoDocumental: this.request.CodfdSubTipoDocumental
      };
    }
}
